import { gradients as gradient } from '../Constants/gradients';
import { colors } from '../Constants/colors';

export const color = name =>
    ({
        white: colors.WHITE,
        black: colors.BLACK,
        yellow: colors.YELLOW,
        lightGrey: colors.LIGHT_GREY,
        grey: colors.GREY,
        darkGrey: colors.DARK_GREY,
        red: colors.RED,
        facebookBlue: colors.FACEBOOK_BLUE,
        mainBlack: colors.MAIN_BLACK,
    }[name]);

export const hoverColors = name =>
    ({
        white: 'rgba(255, 255, 255, 0.75)',
        black: 'rgba(0, 0, 0, 0.75)',
    }[name]);

export const gradients = name =>
    ({
        orange: gradient.DEFAULT_ORANGE,
        green: gradient.KETTLE,
        purple: gradient.PACE,
        blue: gradient.POWER,
        yellow: gradient.CRUSH,
        magento: gradient.GAINS,
    }[name]);



// WEBPACK FOOTER //
// ./src/Assets/color.js